import Cookies from 'js-cookie'

export function userRole(list) {
  if (!Cookies.get("user")) {
    return false
  }
  var user = JSON.parse(Cookies.get("user"))
  //console.log("user=====>",user)
  for (var i = 0;i<list.length;i++){
    var res = list[i]
    for (var z = 0;z<user.length;z++){
      var ress = user[z]
      if (res === ress){
        return  true
      }
    }
  }
  return false
}
